import { Leader } from '../index'
import User from '../models/User'
import { Option } from '../../../components/Form/Inputs/SelectInput'
import ProjectStatus from '../enums/ProjectStatus'

export type ProjectFormValues = {
  name: string
  description: string
  acronym: string
  privacy: boolean
  projectStatus: string
  leaders: Leader[]
  team: User[]
  driveUrl: string
  parent: Option | null
  operational: boolean
  avatar: string
  extension: string
  loggable: boolean
}

export const projectDefaultFormValues: ProjectFormValues = {
  name: '',
  description: '',
  acronym: '',
  privacy: false,
  projectStatus: ProjectStatus.ACTIVE,
  leaders: [],
  team: [],
  driveUrl: '',
  parent: null,
  operational: true,
  avatar: '',
  extension: '',
  loggable: true,
}
